"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _resize = _interopRequireDefault(require("../../hocs/resize"));
var _instrumentPositionSelectors = require("../../redux/selectors/instrumentPositionSelectors");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _InterestBalances = _interopRequireDefault(require("../../components/InterestBalances"));
var _InterestPayments = _interopRequireDefault(require("../InterestPayments"));
var _PageFooterComponent = _interopRequireDefault(require("../../components/PageFooter/PageFooterComponent"));
var _productPositionSelectors = require("../../redux/selectors/productPositionSelectors");
var _interestAccountActions = require("../../redux/actions/interestAccountActions");
var _RatesHeading = _interopRequireDefault(require("./RatesHeading"));
var _RatesGrid = _interopRequireDefault(require("./RatesGrid"));
require("./IbaLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var customClasses = (0, _cssClassesHelper.getBEMClasses)('iba-balances-layout');
var classes = (0, _cssClassesHelper.getBEMClasses)('asset-activity-details-layout');
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('activity');
var IBALayout = function IBALayout(_ref) {
  var selectedAccountId = _ref.selectedAccountId,
    productsList = _ref.productsList,
    getBalances = _ref.getInterestBalances,
    getAccountStatus = _ref.getInterestAccountStatus,
    getInterestRates = _ref.getRates,
    accountStatus = _ref.accountStatus,
    interestRates = _ref.interestRates;
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    getInterestRates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    getBalances();
    getAccountStatus();
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedAccountId]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: customClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "iba-balances"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-bar')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('header-text')
  }, t('Rates'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "earning"
  }, /*#__PURE__*/_react["default"].createElement(_RatesHeading["default"], {
    getAccountStatus: getAccountStatus,
    accountStatus: accountStatus
  }), /*#__PURE__*/_react["default"].createElement(_RatesGrid["default"], {
    productsList: productsList,
    rates: interestRates
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "iba-balances"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_InterestBalances["default"], {
    products: productsList,
    rates: interestRates
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "iba-balances",
    style: {
      marginBottom: '4rem'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_InterestPayments["default"], null)))), /*#__PURE__*/_react["default"].createElement(_PageFooterComponent["default"], null));
};
function mapStateToProps(state) {
  return {
    selectedAccountId: state.user.selectedAccountId,
    selectedInstrument: (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
    productsList: (0, _productPositionSelectors.productPositionAssetsSelector)(state),
    accountStatus: state.interestBearingAccounts.accountStatus,
    interestRates: state.interestBearingAccounts.interestRates
  };
}
var mapDispatchToProps = {
  getInterestBalances: _interestAccountActions.getInterestBalances,
  getInterestAccountStatus: _interestAccountActions.getInterestAccountStatus,
  getRates: _interestAccountActions.getRates
};
var _default = exports["default"] = (0, _resize["default"])((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IBALayout));